import _get from 'lodash/get';
import { Values } from '@lib/interfaces/form';
import { InputTelValue } from '@lib/components/Input/InputTel';

export default function getPhoneNumberPreparedDataFromValues(
  values?: Values,
  name?: string,
): string | null {
  const phoneNumberValue = _get(values, name || 'phoneNumber') as InputTelValue;
  return phoneNumberValue?.phone ? `+${phoneNumberValue.phone}` : null;
}
